import { createI18n } from "vue-i18n";

const messages = {
  en: {
    validation: {
      required: "This field is required.",
      minLength: "This field must have at least {min} characters.",
      email: "This field must be a valid email address.",
      url: "This field must be a valid URL.",
    },
  },
  ko: {
    validation: {
      required: "이 항목은 필수입니다.",
      minLength: "이 항목은 최소 {min}자 이상이어야 합니다.",
      email: "이 항목은 유효한 이메일 주소여야 합니다.",
      url: "이 항목은 유효한 URL이어야 합니다.",
    },
  },
};

const i18n = createI18n({
  legacy: false,
  locale: "ko",
  fallbackLocale: "en",
  messages,
});

export default i18n;
